export const fleetRegNumberRegex = /^[A-Z]{2}[0-9]{2}[A-Z]{1,2}[0-9]{4}$/;

export const messageRegex = /^[a-zA-Z0-9 ,./?;':"<>\[\]{}\\|()!@#$%&*-_+=\n]+$/;

// 1st december
export const voucherImageRelaxationDate = new Date(2020, 11, 1, 0, 0, 0, 0);
// 10-December 2020
export const verifyPackagesEnforceDate = new Date(2021, 11, 10, 0, 0, 0, 0);
// Package must be verified every before 8 days of last verification
export const verifyPackageThreshold = 8;

export enum ServiceType {
  FullLoad = "FullLoad",
  PartLoad = "PartLoad",
  // DoorDelivery = "DoorDelivery",
  // DoorPickup = "DoorPickup",
  IntraCity = "IntraCity",
  PackersAndMovers = "PackersAndMovers",
}

// verify docket receiver by otp from 24-dec
export const verifyDocketReceiverRelaxationDate = new Date(
  2020,
  11,
  24,
  0,
  0,
  0,
  0
);

export const creditorType = [
  { label: "All", value: "" },
  { label: "PayTM", value: "PayTM" },
  { label: "RedBus", value: "RedBus" },
  { label: "Mantis", value: "Mantis" },
  { label: "Branch", value: "Branch" },
  { label: "Agent", value: "Agent" },
  { label: "Other", value: "Other" },
];

export const sendMemoRestriction = 10;

export const denominator = 2700;

export const reCaptchaKey = "6Ld5ft8bAAAAADAjHq8-bSS3meE2QVvRc7Yu0egS";

export const gstRegex = /(\d{2}.{10}\d[A-Z].)|^$/;

export const bookingGstForceNameUpdateReq = false;
export const bookingMaxGstCount = 5;
export const bookingMaxSecondaryContactCount = 4;
export const bookingMaxNameCount = 3;

export const COLOR = {
  PRIMARY_50: "#ccebff",
  PRIMARY_100: "#1aa3ff",
  PRIMARY_400: "#007acc",
  PRIMARY_900: "##002e4d",
};

export const mapStyleTheme = [
  { elementType: "geometry", stylers: [{ color: "#EAF6FF" }] }, // Soft pastel blue background
  { elementType: "labels.text.fill", stylers: [{ color: "#4A6FA5" }] }, // Softer muted blue-gray text
  { elementType: "labels.text.stroke", stylers: [{ color: "#F2F9FF" }] }, // Light pastel outline
  {
    featureType: "water",
    elementType: "geometry",
    stylers: [{ color: "#9BD3F3" }],
  }, // Darker pastel blue water for better visibility
  {
    featureType: "road",
    elementType: "geometry",
    stylers: [{ color: "#D9D9D9" }],
  }, // Light gray roads
  {
    featureType: "road",
    elementType: "geometry.stroke",
    stylers: [{ color: "#B0B0B0" }],
  }, // Slightly darker gray road borders
  {
    featureType: "road.highway",
    elementType: "geometry.fill",
    stylers: [{ color: "#B0B0B0" }],
  }, // Medium gray highways for better contrast
  {
    featureType: "road.highway",
    elementType: "geometry.stroke",
    stylers: [{ color: "#8E8E8E" }],
  }, // Stronger outline for better readability
  {
    featureType: "road.arterial",
    elementType: "geometry",
    stylers: [{ color: "#C4C4C4" }],
  }, // Darker gray arterial roads
  {
    featureType: "road.arterial",
    elementType: "geometry.stroke",
    stylers: [{ color: "#9E9E9E" }],
  }, // Defined arterial road strokes
  {
    featureType: "road.local",
    elementType: "geometry",
    stylers: [{ color: "#E0E0E0" }],
  }, // Light gray local roads
  {
    featureType: "road.local",
    elementType: "geometry.stroke",
    stylers: [{ color: "#B3B3B3" }],
  }, // Slightly darker local road borders
  {
    featureType: "road.local",
    elementType: "labels",
    stylers: [{ visibility: "off" }],
  }, // Hide local road labels
  {
    featureType: "poi.park",
    elementType: "geometry",
    stylers: [{ color: "#D7F3E3" }],
  }, // Soft pastel green for parks
  {
    featureType: "poi",
    elementType: "labels",
    stylers: [{ visibility: "off" }],
  }, // Hide POI labels
  {
    featureType: "transit",
    elementType: "geometry",
    stylers: [{ color: "#BFDFF2" }],
  }, // Softer pastel transit lines
  {
    featureType: "transit",
    elementType: "labels",
    stylers: [{ visibility: "off" }],
  }, // Hide transit labels for a cleaner UI
  {
    featureType: "landscape",
    elementType: "geometry",
    stylers: [{ color: "#F5FAFF" }],
  }, // Pastel blue-gray land areas
];
